// brightresolve_app/src/App.js
import React from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route, useLocation } from 'react-router-dom';

import { AuthProvider } from './context/AuthContext';
import { InsightsProvider } from './context/InsightsContext';
import { UserPreferencesProvider } from './context/UserPreferencesContext';

import Navbar from './components/Navbar';
import Home from './components/Home';
import AuthLanding from './components/AuthLanding';
import Login from './components/Login';
import Register from './components/Register';
import Chat from './components/Chat';
import Profile from './components/Profile';
import Settings from './components/Settings';
import InsightsDashboard from './components/InsightsDashboard';
import AdminAuditLog from './components/AdminAuditLog';
import NotFoundPage from './components/NotFoundPage';
import ProtectedRoute from './components/ProtectedRoute';
import VoiceLab from './components/chat/VoiceLab';
import PublicInfoPage from './components/PublicInfoPage';
import PasswordRecovery from './components/PasswordRecovery';

function AppRoutes() {
  const location = useLocation();
  const hideNavbar = ['/login', '/register', '/auth', '/recover', '/reset-password'].includes(location.pathname);

  return (
    <>
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/auth" element={<AuthLanding />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/recover" element={<PasswordRecovery />} />
        <Route path="/reset-password" element={<PasswordRecovery />} />

        <Route path="/terms" element={<PublicInfoPage page="terms" />} />
        <Route path="/privacy" element={<PublicInfoPage page="privacy" />} />
        <Route path="/contact" element={<PublicInfoPage page="contact" />} />
        <Route path="/support" element={<PublicInfoPage page="support" />} />

        <Route path="/dashboard" element={<Navigate to="/chat" replace />} />

        <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <Chat />
            </ProtectedRoute>
          }
        />

        <Route
          path="/voice-lab"
          element={
            <ProtectedRoute>
              <VoiceLab />
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />

        <Route
          path="/insights"
          element={
            <ProtectedRoute>
              <InsightsDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/audit-log"
          element={
            <ProtectedRoute>
              <AdminAuditLog />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

function AppContent() {
  return <AppRoutes />;
}

export default function App() {
  return (
    <AuthProvider>
      <UserPreferencesProvider>
        <InsightsProvider>
          <Router>
            <AppContent />
          </Router>
        </InsightsProvider>
      </UserPreferencesProvider>
    </AuthProvider>
  );
}
